export const LEAGUE = "Telangana–Andhra T10 League";
export const CONTACT = { email: "info@cgnsports.com", phone: "+91 81792 92920", tel: "+918179292920" };

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/teams", label: "Teams" },
  { to: "/players", label: "Players" },
  { to: "/fixtures", label: "Fixtures & Results" },
  { to: "/venues", label: "Venues" },
  { to: "/franchise", label: "Franchise" },
  { to: "/media", label: "Media" },
  { to: "/sponsors", label: "Sponsors" },
  { to: "/news", label: "News" },
  { to: "/contact", label: "Contact" },
];

export const NEWS_CATEGORIES = ["League Announcements", "Franchise News", "Player News", "Tournament Updates", "Sponsorship Announcements", "Media Releases"];

export const SPONSOR_TIERS = [
  { name: "Title Sponsor", desc: "League-wide naming rights and the most prominent brand presence across every touchpoint." },
  { name: "Associate Sponsor", desc: "High-visibility association across matchdays, digital channels and league communications." },
  { name: "Official Partners", desc: "Category-exclusive partnerships for brands that want to power the league experience." },
  { name: "Team Sponsors", desc: "Align with an individual franchise and its city, fans and local identity." },
  { name: "Digital Partners", desc: "Reach fans across social, streaming and digital content built around the league." },
];

export const SOCIALS = [
  { label: "Instagram", href: "#", key: "instagram" },
  { label: "YouTube", href: "#", key: "youtube" },
  { label: "X", href: "#", key: "x" },
  { label: "Facebook", href: "#", key: "facebook" },
];
